import { render, staticRenderFns } from "./LearningGroupStudentTable.vue?vue&type=template&id=8e221682&"
import script from "./LearningGroupStudentTable.vue?vue&type=script&lang=ts&"
export * from "./LearningGroupStudentTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports